var _dec, _class;
import { mixins, Options } from 'vue-class-component';
import { PaginationViewModel } from './PaginationViewModel';
let Pagination = (_dec = Options({
  props: {
    totalCount: Number,
    type: String
  },
  emits: ['on-change']
}), _dec(_class = class Pagination extends mixins(PaginationViewModel) {}) || _class);
export { Pagination as default };